<script lang="ts">
import { h, defineComponent, type VNode } from 'vue';
export default defineComponent({
  name: 'AppIcon',

  props: {
    color: {
      type: String,
      default: undefined,
    },
    small: Boolean,
    large: Boolean,
  },

  render (): VNode | VNode[] {
    const { color, small, large } = this.$props;
    const colorClass = color ? `text-${color}` : '';
    const iconFontSize = small ? '16px' : large ? '32px' : '24px';

    return h('i', {
      class: `v-icon notranslate mdi ${this.$slots.default?.()[0].children} v-theme--light ${colorClass}`,
      style: { fontSize: iconFontSize },
    });
  }
});
</script>
